export const TaskTemplateStatus = {
  Active: 'Active',
  Inactive: 'Inactive'
};
